import { logCoreUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import type { ProactiveDraftGenerationProperties } from './types';

export type ProactiveDraftDiscardSource = 'ComposeDiscard' | 'ReadingPaneDelete' | 'ListDelete';
export type ProactiveDraftRenderLocation = 'ReadingPane' | 'Compose';

function getCommonProperties(generationProperties: ProactiveDraftGenerationProperties | undefined) {
    return {
        requestId: generationProperties?.requestId,
        sydneyConversationId: generationProperties?.sydneyConversationId,
        generationCreatedDateTime: generationProperties?.createdDateTime,
    };
}

export function logProactiveDraftRendered(
    mailboxInfo: MailboxInfo,
    generationProperties: ProactiveDraftGenerationProperties | undefined,
    location: ProactiveDraftRenderLocation
): void {
    logCoreUsage('ProactiveDraft_Rendered', mailboxInfo, {
        location,
        ...getCommonProperties(generationProperties),
    });
}

export function logProactiveDraftOpenedForEditing(
    mailboxInfo: MailboxInfo,
    generationProperties: ProactiveDraftGenerationProperties | undefined
): void {
    logCoreUsage('ProactiveDraft_OpenedForEditing', mailboxInfo, {
        ...getCommonProperties(generationProperties),
    });
}

export function logProactiveDraftDiscarded(
    mailboxInfo: MailboxInfo,
    generationProperties: ProactiveDraftGenerationProperties | undefined,
    source: ProactiveDraftDiscardSource
): void {
    logCoreUsage('ProactiveDraft_Discarded', mailboxInfo, {
        source,
        ...getCommonProperties(generationProperties),
    });
}
